<template>
  <div v-if="show" class="calculator-popup shadow-2xl border-0 animate-fade-in">
    <div class="calc-header d-flex justify-content-between align-items-center py-3 px-4 pb-2">
      <h6 class="mb-0 fw-bold text-dark">Kalkulator</h6>
      <button @click="$emit('close')" class="btn btn-icon-round"><i class="fa fa-times"></i></button>
    </div>
    <div class="calc-inner px-4 pb-4">
      <div class="display-container mb-3">
        <div class="prev-expr text-muted small text-end">{{ prevExpression }}</div>
        <div class="current-display text-dark fw-bold text-end">{{ display || '0' }}</div>
      </div>
      <div class="calc-grid">
        <button v-for="btn in buttons" :key="btn" @click="press(btn)" :class="getBtnClass(btn)">
          {{ btn }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['show'],
  data() {
    return {
      display: '',
      prevExpression: '',
      buttons: ['C', '÷', '×', 'DEL', '7', '8', '9', '-', '4', '5', '6', '+', '1', '2', '3', '=', '0', '.', '%']
    };
  },
  watch: {
    show(newVal) {
      if (newVal) {
        window.addEventListener('keydown', this.handleKeyDown);
      } else {
        window.removeEventListener('keydown', this.handleKeyDown);
      }
    }
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    handleKeyDown(e) {
      const key = e.key;
      
      // Prevent default behavior for some keys to avoid page scroll/navigation
      if (['/', '*', '+', '-', 'Enter', 'Backspace', 'Escape'].includes(key)) {
        e.preventDefault();
      }

      if (/[0-9.]/.test(key)) {
        this.press(key);
      } else if (key === '+') {
        this.press('+');
      } else if (key === '-') {
        this.press('-');
      } else if (key === '*') {
        this.press('×');
      } else if (key === '/') {
        this.press('÷');
      } else if (key === '%') {
        this.press('%');
      } else if (key === 'Enter' || key === '=') {
        this.press('=');
      } else if (key === 'Backspace') {
        this.press('DEL');
      } else if (key === 'Escape' || key === 'c' || key === 'C') {
        this.press('C');
      }
    },
    getBtnClass(btn) {
      if (['+', '-', '×', '÷', '='].includes(btn)) return 'btn-op';
      if (['C', 'DEL', '%'].includes(btn)) return 'btn-func';
      return 'btn-num';
    },
    press(btn) {
      if (btn === 'C') {
        this.display = '';
        this.prevExpression = '';
      } else if (btn === 'DEL') {
        this.display = this.display.slice(0, -1);
      } else if (btn === '=') {
        try {
          if (!this.display) return;
          this.prevExpression = this.display + ' =';
          let expr = this.display.replace(/×/g, '*').replace(/÷/g, '/');
          this.display = String(eval(expr));
        } catch {
          this.display = 'Error';
        }
      } else {
        if (this.display === 'Error') this.display = '';
        this.display += btn;
      }
    }
  }
}
</script>

<style scoped>
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}
.animate-fade-in {
  animation: fadeIn 0.3s ease-out;
}
.calculator-popup {
  position: absolute;
  top: 75px;
  right: 150px;
  width: 280px;
  background: #ffffff;
  border-radius: 24px;
  z-index: 2000;
  box-shadow: 0 20px 50px rgba(0,0,0,0.15);
}
.btn-icon-round {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  background: #f8f9fa;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  transition: all 0.2s;
}
.btn-icon-round:hover {
  background: #ff4d4f;
  color: white;
}
.display-container {
  background: #f8f9fa;
  border-radius: 16px;
  padding: 12px 16px;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.prev-expr {
  font-size: 11px;
  min-height: 16px;
}
.current-display {
  font-size: 24px;
  overflow-x: auto;
  white-space: nowrap;
}
.calc-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}
.calc-grid button {
  height: 48px;
  border: none;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 600;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-num {
  background: #f1f3f5;
  color: #495057;
}
.btn-num:hover { background: #e9ecef; }

.btn-op {
  background: #28a745;
  color: white;
}
.btn-op:hover { background: #218838; transform: scale(1.05); }

.btn-func {
  background: #fff3cd;
  color: #856404;
}
.btn-func:hover { background: #ffeeba; }

.calc-grid button:active {
  transform: scale(0.95);
}
</style>
